import { ERC20 } from 'src/common/types/models/Tokens'
import { BASE_KNOWN_ERC20 } from './consts'

export const BASE_KNOWN_TOKENS: Record<string, ERC20> = {
  SMT: {
    id: '0x2974dc646e375e83bd1c0342625b49f288987fa4',
    contractAddress: '0x2974dc646e375e83bd1c0342625b49f288987fa4', // Замените на реальный адрес
    name: 'Swarm Markets',
    symbol: 'SMT',
    decimals: 18,
    ...BASE_KNOWN_ERC20,
  },
  USDC: {
    id: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    contractAddress: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    name: 'USD Coin',
    symbol: 'USDC',
    decimals: 6,
    ...BASE_KNOWN_ERC20,
    logo: 'https://static.alchemyapi.io/images/assets/3408.png',
  },
  DAI: {
    id: '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
    contractAddress: '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
    name: 'Dai Stablecoin',
    symbol: 'DAI',
    decimals: 18,
    ...BASE_KNOWN_ERC20,
    logo: 'https://static.alchemyapi.io/images/assets/4943.png',
  },
  WETH: {
    id: '0x4200000000000000000000000000000000000006',
    contractAddress: '0x4200000000000000000000000000000000000006',
    name: 'Wrapped Ether',
    symbol: 'WETH',
    decimals: 18,
    ...BASE_KNOWN_ERC20,
  },
  WBTC: {
    id: '0x0555E30da8f98308EdB960aa94C0Db47230d2B9c',
    contractAddress: '0x0555E30da8f98308EdB960aa94C0Db47230d2B9c',
    name: 'Wrapped Bitcoin',
    symbol: 'WBTC',
    decimals: 8,
    ...BASE_KNOWN_ERC20,
    logo: 'https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons/svg/color/wbtc.svg',
  },
}
